import type { FC, ReactNode } from 'react'

import { Minus, Plus } from 'lucide-react'
import { cn } from '@/lib/utils'

interface QuantityStepperProps {
    value: number
    min?: number
    max?: number
    onChange: (value: number) => void
    size?: 'sm' | 'md'
    label?: string
    className?: string
}

export const QuantityStepper: FC<QuantityStepperProps> = ({ value, min = 1, max = 99, onChange, size = 'md', label = 'Jumlah', className }): ReactNode => {
    const small = size === 'sm'
    const buttonClass = cn(
        'flex items-center justify-center rounded-full text-brand-choco transition-colors hover:bg-brand-yellow disabled:pointer-events-none disabled:opacity-35 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-orange/40',
        small ? 'size-8' : 'size-10'
    )

    return (
        <div className={cn('inline-flex items-center rounded-full border-2 border-brand-choco bg-white p-0.5', className)} role='group' aria-label={label}>
            <button type='button' className={buttonClass} onClick={() => onChange(Math.max(min, value - 1))} disabled={value <= min} aria-label='Kurangi jumlah'>
                <Minus className={small ? 'size-3.5' : 'size-4'} />
            </button>
            <input
                type='number'
                inputMode='numeric'
                min={min}
                max={max}
                value={value}
                onChange={event => {
                    const next = Number(event.target.value)

                    if (Number.isFinite(next)) onChange(Math.max(min, Math.min(max, Math.round(next))))
                }}
                className={cn('bg-transparent text-center font-heading font-semibold text-brand-choco outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none', small ? 'w-8 text-sm' : 'w-11 text-base')}
                aria-label={label}
            />
            <button type='button' className={buttonClass} onClick={() => onChange(Math.min(max, value + 1))} disabled={value >= max} aria-label='Tambah jumlah'>
                <Plus className={small ? 'size-3.5' : 'size-4'} />
            </button>
        </div>
    )
}
